import { parsePesel } from '@sigma/common/i18n/parsePesel.js';
import * as l from './peselValidation.loc.js';
/**
 * PESEL validator that checks if the value is a valid PESEL number
 * @param options - Validator options
 */
export function peselValidator(options = {}) {
    return {
        async: false,
        validate: (value, ctx) => {
            const pesel = value?.toString().trim();
            if (!pesel) {
                return undefined;
            }
            const result = parsePesel(pesel);
            if (result !== null) {
                return undefined;
            }
            if (options.message) {
                return options.message(pesel, ctx);
            }
            return l.invalid(ctx.lang);
        },
    };
}
//# sourceMappingURL=peselValidation.js.map